import { render } from "./ContentsHeading.vue?vue&type=template&id=48677d40&scoped=true"
import script from "./ContentsHeading.vue?vue&type=script&lang=js"
export * from "./ContentsHeading.vue?vue&type=script&lang=js"

import "./ContentsHeading.vue?vue&type=style&index=0&id=48677d40&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48677d40"]])

export default __exports__